import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, FlexRow } from "@similarweb/ui-components";

export const InputContainer = styled(FlexRow)`
    justify-content: center;
`;

export const Input = styled.input`
    margin: 0;
    border: unset;
    box-shadow: unset;
    width: 620px;
    outline: none;

    padding: 19px 0;
    box-sizing: border-box;
    border-bottom: 2px solid ${colorsPalettes.blue[400]};

    &::placeholder {
        ${setFontVariant("body2", colorsPalettes.carbon[100])}
    }
`;

const ItemText = styled.p`
    margin: 0;
    ${setFontVariant("input2", colorsPalettes.carbon[400])}
    line-height: 24px;
    padding-left: 8px;
`;

export const ClickText = styled.p`
    margin: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[300])}
`;

export const TextButtonWrapper = styled(FlexRow)`
    align-items: center;
`;

export const SelectedItemsContainer = styled(FlexRow)`
    padding: 10px 16px;
    width: 100%;
    justify-content: space-between;
    background: ${colorsPalettes.blue[400]};
    height: 40px;
`;

export const SelectedItemsText = styled.p`
    ${setFontVariant("body1", colorsPalettes.carbon[0])}
    margin: 0;
    padding-right: 8px;
`;

export const StyledButton = styled(Button)`
    div {
        ${setFontVariant("button", colorsPalettes.carbon[0])}
        color: ${colorsPalettes.carbon[0]} !important;
    }
`;

export const AddPlaceholder = styled(FlexRow)<{ isIncluded?: boolean; isLimitReached?: boolean }>`
    padding: 8px 15px;
    height: 26px;
    background: ${colorsPalettes.carbon[25]};
    align-items: center;

    ${({ isIncluded, isLimitReached }) => {
        if (!isIncluded && !isLimitReached) {
            return css`
                cursor: pointer;
                transition: background 0.2s linear;
                background: ${colorsPalettes.bluegrey[100]};

                &:hover {
                    background: ${colorsPalettes.blue[100]};
                }
            `;
        }

        if (isLimitReached) {
            return css`
                cursor: pointer;
                transition: background 0.2s linear;

                &:hover {
                    background: ${colorsPalettes.carbon[50]};
                }
            `;
        }
    }}
`;

export const KeywordName = styled.p`
    margin: 0;
    padding: 0 8px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])}
`;

export const MatchingKWWrapper = styled.div`
    padding: 16px;
`;

export const MatchingKWTitle = styled.p`
    margin: 0;
    padding: 8px 0 24px;
    text-transform: uppercase;
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[250])}
`;

export const MatchingKWCountText = styled.p`
    margin: 0;
    padding-left: 8px;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])}
`;

export const CheckBoxWrapper = styled(FlexRow)`
    align-items: center;
    padding-bottom: 8px;
`;

export const DividerWrapper = styled.div`
    width: 100%;
    padding: 0 24px;
`;

export const Divider = styled.span`
    display: block;
    width: 556px;
    height: 1px;
    margin: 8px 0;
    background: ${colorsPalettes.carbon[50]};
`;

export const ErrorTextWrapper = styled(FlexRow)`
    padding-left: 8px;
    align-items: center;
`;

export const ErrorText = styled.p`
    padding-right: 8px;
    margin: 0;
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])}
`;
